import { createApp } from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

import App from './components/App.vue';
import Schedule from './components/Schedule.vue';

if(document.getElementById('nada-form')) {
    createApp(App)
        .use(VueReCaptcha, { siteKey: '6LfA8_siAAAAABnoGTdCgeZ4CuR67pRwKTgaYPED' })
        .mount('#nada-form');
}

if(document.getElementById('reco-engine')) {
    createApp(RecoEngine).mount('#reco-engine');
}

if(document.getElementById('schedule')) {
    createApp(Schedule).mount('#schedule');
}
